// extracted by mini-css-extract-plugin
export default {"itemcontainer":"RoutetteItemsProperty_itemcontainer__c9HgH","itemsettings":"RoutetteItemsProperty_itemsettings__LDFnN"};